import i18next from 'i18next';

export const UnsavedForms = {
  medication: 'medication',
  clinicalNotes: 'clinicalNotes',
} as const;

export const UnsavedMessages = {
  medication: i18next.t('unsavedMessages.medication'),
  clinicalNotes: i18next.t('unsavedMessages.clinicalNotes'),
} as const;
